function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { withStyles } from 'common/util/react';
import { emitTrackEvent } from 'common/util/dom';
import { SelectTheme } from 'common/components/select/constants';
import { RetentionTrackingEvents as Events } from 'common/report/retention/util/constants';
import { MenuChangeEvent } from 'common/components/select/types';
import { SectionReact } from 'common/components/section';
import { SelectReact } from 'common/components/select';
import { useTranslation } from 'common/i18n/hooks';
import { Section, SectionItem } from 'common/components/items-menu/types';
import { RetentionType } from 'common/types/reports/bookmark';
import { RetentionQuerySettingsUpdate } from '../types';
import styles from './index.module.styl';
import css from './index.module.styl?inline';
type RetentionQuerySettingsProps = {
  countingMethod: string;
  retentionType: RetentionType | undefined;
  onChange: (ev: RetentionQuerySettingsUpdate) => void;
};
const FREQUENCY_COUNTING_METHOD: Readonly<Section<string> & {
  title: string;
}> = Object.freeze({
  title: "Cumulative vs Non-cumulative Frequency",
  items: [{
    label: _ref => {
      let {
        t
      } = _ref;
      return t("retention.cumulative-frequency");
    },
    value: "cumulative",
    tooltip: {
      text: _ref2 => {
        let {
          t
        } = _ref2;
        return t("retention.cumulative-frequency-tooltip");
      }
    }
  }, {
    label: _ref3 => {
      let {
        t
      } = _ref3;
      return t("retention.non-cumulative-frequency");
    },
    value: "non-cumulative",
    tooltip: {
      text: _ref4 => {
        let {
          t
        } = _ref4;
        return t("retention.non-cumulative-frequency-tooltip");
      }
    }
  }]
});
const DEFAULT_COLLAPSIBLE_OPEN = true;
export const RetentionQuerySettings = (props: RetentionQuerySettingsProps) => {
  var _FREQUENCY_COUNTING_M;
  const {
    t
  } = useTranslation();
  const [isSelectMenuHovered, setIsSelectMenuHovered] = React.useState(false);
  const [isSelectMenuOpen, setIsSelectMenuOpen] = React.useState(false);
  const handleCollapsibleQuerySectionChange = (state: `open` | `closed`) => {
    const isBlockOpen = state === "open";
    emitTrackEvent(this, {
      eventName: Events.ClickedAdvancedQuerySettings,
      eventPrefix: "mp-query-builder",
      props: {
        report: "retention",
        Action: isBlockOpen ? "expand" : "collapse"
      }
    });
  };
  const handleSelectChange = (item: SectionItem) => {
    const {
      value
    } = item;
    const isAddiction = props.retentionType === "addiction";
    setIsSelectMenuOpen(false);
    setIsSelectMenuHovered(false);
    props.onChange(isAddiction ? {
      retentionCumulative: value === "cumulative"
    } : {
      unboundedMode: value
    });
  };
  const handleSelectMenuChange = (ev: MenuChangeEvent) => {
    setIsSelectMenuOpen(ev.detail.isOpen);
  };
  const handleSelectMenuMouseEnter = () => {
    setIsSelectMenuHovered(true);
  };
  const handleSelectMenuMouseLeave = () => {
    setIsSelectMenuHovered(false);
  };
  return <div className={styles.retentionQuerySettings} data-sentry-component="RetentionQuerySettings" data-sentry-source-file="index.tsx">
      <SectionReact className={styles.retentionQuerySection} headerTitle={t("retention.frequency-criteria")} isClosed={!DEFAULT_COLLAPSIBLE_OPEN} nonCollapsible onChange={ev => "detail" in ev && handleCollapsibleQuerySectionChange(ev.detail.state)} data-sentry-element="SectionReact" data-sentry-source-file="index.tsx">
        <div>
          <SelectReact className={styles.retentionQuerySelect} elref='retentionQuerySelect' alwaysShowCaret={isSelectMenuHovered || isSelectMenuOpen} icon={{
          leftIcon: "column-select",
          rightIcon: "double-caret"
        }} theme={SelectTheme.Tertiary} menuWidth={204} sections={[_objectSpread(_objectSpread({}, FREQUENCY_COUNTING_METHOD), {}, {
          items: (_FREQUENCY_COUNTING_M = FREQUENCY_COUNTING_METHOD.items) === null || _FREQUENCY_COUNTING_M === void 0 ? void 0 : _FREQUENCY_COUNTING_M.map(i => _objectSpread(_objectSpread({}, i), {}, {
            isSelected: i.value === props.countingMethod
          }))
        })]} onMenuChange={handleSelectMenuChange} onChange={ev => "detail" in ev && handleSelectChange(ev.detail.item)} onMouseEnter={handleSelectMenuMouseEnter} onMouseLeave={handleSelectMenuMouseLeave} data-sentry-element="SelectReact" data-sentry-source-file="index.tsx" />
        </div>
      </SectionReact>
    </div>;
};
export const RetentionQuerySettingsReact = withStyles(RetentionQuerySettings, css);